import { useMutation } from '@tanstack/react-query';

export const useDeleteTellMoneyConsent = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return useMutation(async (consentId: string) => {});
};
